<template>
  <div class="queue-timing-container" data-testid="timings-container">
    <!-- AUTO QUEUE CLEARING -->
    <section class="d-flex flex-wrap justify-content-between rounded-30 gap-2">
      <div class="d-flex gap-2 my-auto">
        <h2 id="auto-queue-clearing-title" class="queue-header-text">
          Auto Queue Clearing
        </h2>
        <HelpCenterButton
          use-securly-design-system
          content-key="auto_queue_clearing_v002"
        />
      </div>
      <hr class="queue-header-horizontal-line flex-grow-1 align-self-center" />
    </section>
    <!-- AUTO QUEUE CLEARING -->

    <!-- FORMS AND SELECT CLEAR TIMES -->
    <div class="queue-forms-container">
      <AddClearTimeForm />

      <ClearTimeList />
    </div>
    <!-- FORMS AND SELECT CLEAR TIMES -->
  </div>
</template>

<script>
import HelpCenterButton from "@/v3components/HelpCenterButton.vue"
import AddClearTimeForm from "@/v3components/Queue/QueueTime/AddClearTimeForm.vue"
import ClearTimeList from "@/v3components/Queue/QueueTime/ClearTimeList.vue"

export default {
  name: "QueueTimingsContainer",
  components: {
    HelpCenterButton,
    AddClearTimeForm,
    ClearTimeList
  }
}
</script>
